
import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import MouthQuadrant from './MouthQuadrant';

import './CustomGridQuadrant.css'


//  Component displaying a whole odontogram.
const OdontogramDisplay = ({selectedObjects, parentHandleSelectQuadrant, parentHandleSelectRoot, parentHandleSelectOclusal, parentHandleSelectTooth, lan}) => {
  return (
    <Container fluid className="grid-container">
        <Row>
            <Col 
            xs={6}
            className="grid-cell"
            >
                <MouthQuadrant
                selectedObjects={selectedObjects.slice(0, 8).reverse()}
                parentHandleSelectQuadrant={parentHandleSelectQuadrant}
                parentHandleSelectRoot={parentHandleSelectRoot}
                parentHandleSelectOclusal={parentHandleSelectOclusal}
                parentHandleSelectTooth={parentHandleSelectTooth}
                quadrant_number={1}
                lan={lan}
                />
            </Col>
            <Col
            xs={6}
            className="grid-cell"
            >
                <MouthQuadrant
                selectedObjects={selectedObjects.slice(8, 16)}
                parentHandleSelectQuadrant={parentHandleSelectQuadrant}
                parentHandleSelectRoot={parentHandleSelectRoot}
                parentHandleSelectOclusal={parentHandleSelectOclusal}
                parentHandleSelectTooth={parentHandleSelectTooth}
                quadrant_number={2}
                lan={lan}
                />
            </Col>
        </Row>
        <Row>
            <Col
            xs={6}
            className="grid-cell"
            >
                <MouthQuadrant
                selectedObjects={selectedObjects.slice(16, 24).reverse()}
                parentHandleSelectQuadrant={parentHandleSelectQuadrant}
                parentHandleSelectRoot={parentHandleSelectRoot}
                parentHandleSelectOclusal={parentHandleSelectOclusal}
                parentHandleSelectTooth={parentHandleSelectTooth}
                quadrant_number={3}
                lan={lan}
                />
            </Col>
            <Col
            xs={6}
            className="grid-cell"
            >
                <MouthQuadrant
                selectedObjects={selectedObjects.slice(24, 32)}
                parentHandleSelectQuadrant={parentHandleSelectQuadrant}
                parentHandleSelectRoot={parentHandleSelectRoot}
                parentHandleSelectOclusal={parentHandleSelectOclusal}
                parentHandleSelectTooth={parentHandleSelectTooth}
                quadrant_number={4}
                lan={lan}
                />
             </Col>
        </Row>
    </Container>
  );
};

export default OdontogramDisplay;
